/* eslint-disable key-spacing */
export const defaultInputTheme = {
  closeIcon:                'input-clear-icon',
  icon:                     'input-icon',
  iconLeft:                 'icon-left',
  iconRight:                'icon-right',
  input:                    'input-element',
  inputWrapper:             'input-element-wrapper',
  inputWrapperDisabled:     'disabled',
  inputWrapperFocused:      'focused',
  inputWrapperInvalid:      'danger',
  inputWrapperRequired:     'required',
  prefix:                   'input-prefix',
  suffix:                   'input-suffix',
  wrapper:                  'input-wrapper',
};
/* eslint-enable key-spacing */
